export const types = {
  SET_MUSIC_LINK_URL_PARTS: "SET_MUSIC_LINK_URL_PARTS",
  ADD_MUSIC_LINK_URL_PART: "ADD_MUSIC_LINK_URL_PART",
  UPDATE_MUSIC_LINK_URL_PART: "UPDATE_MUSIC_LINK_URL_PART",
  DELETE_MUSIC_LINK_URL_PART: "DELETE_MUSIC_LINK_URL_PART",
  // legacy aliases
  GET_MUSIC_LINKS: "SET_MUSIC_LINK_URL_PARTS",
  ADD_NEW_MUSIC_LINK: "ADD_MUSIC_LINK_URL_PART",
};

export const setMusicLinks = payload => ({
  type: types.SET_MUSIC_LINK_URL_PARTS,
  payload,
});

export const addMusicLinks = payload => ({
  type: types.ADD_MUSIC_LINK_URL_PART,
  payload,
});

export const addMusicLinkUrlPart = payload => ({
  type: types.ADD_MUSIC_LINK_URL_PART,
  payload,
});

export const updateMusicLinkUrlPart = payload => ({
  type: types.UPDATE_MUSIC_LINK_URL_PART,
  payload,
});

export const deleteMusicLinkUrlPart = payload => ({
  type: types.DELETE_MUSIC_LINK_URL_PART,
  payload,
});
